import { Component, Input } from "@angular/core";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-driver-details",
  templateUrl: "./driver-details.component.html",
  styleUrl: "./driver-details.component.scss",
  standalone: false
})
export class DriverDetailsComponent {
  @Input() driverDetails: any;

  constructor(public helper: Helper) {}

  handleImageError(event: any): void {
    event.target.src = this.helper.DefaultImages.DefaultUserImage;
  }
}
